import { useAuth0 } from '@auth0/auth0-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useStore } from '../../hooks/use-store';
import { MyIDEXXUserType } from '../../types/brm-types';
import { LoadingSpinnerWithContent } from '../LoadingSpinnerWithContent/LoadingSpinnerWithContent';

interface AuthorizerProps {
  children: any;
}

const JSON_TAB_SIZE = 2;

const Authorizer = observer((props: AuthorizerProps) => {
  const { children } = props;
  const {
    getAccessTokenSilently,
    loginWithRedirect,
    isAuthenticated,
    isLoading,
    logout,
    error,
    user,
  } = useAuth0<MyIDEXXUserType>();
  const { apiStore: store, globalStore } = useStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const sapIdParam = searchParams.get('sapId');

  useEffect(() => {
    if (sapIdParam) {
      runInAction(() => {
        globalStore.selectedSap = { id: sapIdParam, name: '' };
      });
      searchParams.delete('sapId');
      setSearchParams(searchParams);
    } else if (!globalStore.sapId) {
      globalStore.toMyCsDashboard();
    }
  }, [sapIdParam, searchParams, setSearchParams, globalStore]);

  useEffect(() => {
    if (isAuthenticated) {
      store.authenticate(getAccessTokenSilently, logout, user);
    }
  }, [getAccessTokenSilently, isAuthenticated, logout, store, user]);

  useEffect(() => {
    if (store.sapId && !isLoading && !isAuthenticated) {
      void loginWithRedirect({
        authorizationParams: { login_hint: store.userEmail || undefined, scope: '*' },
      });
    }
  }, [store.sapId, isAuthenticated, isLoading, loginWithRedirect, store.userEmail]);

  if (error)
    return (
      <div>
        <section id='error-page'>
          <pre role='global-error'>{JSON.stringify(error, null, JSON_TAB_SIZE)}</pre>
        </section>
      </div>
    );
  return store.isAuthenticated ? (
    children
  ) : (
    <LoadingSpinnerWithContent size='large'>
      {globalStore.loggingOut
        ? 'Signing you out'
        : 'One moment while we retrieve your affiliated practices'}
    </LoadingSpinnerWithContent>
  );
});

export default Authorizer;
